var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-off",on:{"click":function($event){return _vm.$emit('jumpToOFF', 'shop')}}},[(_vm.doc)?_c('slice-body',{attrs:{"slices":_vm.doc.data.body}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }